import { useContext } from 'react';
import { Button, InviteMore, MembershipProgress, ReferralList } from '../components';
import { UserContext } from '../contexts/user.context';
import { UserProviderValue } from '../models';
import { MembershipModel } from '../models/membership.model';
export function ReferralCenterPage() {
   const { userReferrals, setUserReferrals, user } = useContext<UserProviderValue>(UserContext);

   return (
      <div className="flex flex-col gap-4">
         <InviteMore
            referralCode={user?.referralCode ?? ''}
            signupCount={userReferrals?.counts.signups ?? 0}
            activeMembers={userReferrals?.counts.profilesCompleted ?? 0}
            referredBy={user?.referredBy ?? null}
            username={(user?.username ?? user?.fullname?.split(' ')[0] ?? '').split(' ')[0] ?? ''}
         />

         {/* {userReferrals?.counts.membershipsPurchased !== null && (
            <div className="flex flex-col gap-4">
               {userReferrals?.membershipRewards?.map((reward, index) => {
                  return (
                     <MembershipProgress
                        key={index}
                        membership={reward.membership as MembershipModel}
                        total={reward.goal}
                        current={reward.current}
                        redeemed={reward.redeemed}
                        allowRedeem={reward.allowRedeem}
                     />
                  );
               })}
            </div>
         )}
         {userReferrals.userReferrals?.length === 0 ? null : <ReferralList userReferrals={userReferrals.userReferrals ?? []} />}
         {(userReferrals.pagination.total ?? 0) > (userReferrals.userReferrals?.length ?? 0) && (
            <div className="flex justify-center">
               <Button
                  type={'white'}
                  title="Load More"
                  onClick={() => setUserReferrals({ ...userReferrals, pagination: { ...userReferrals.pagination, page: userReferrals.pagination.page + 1 } })}></Button>
            </div>
         )} */}
      </div>
   );
}
